import { Alert, Button } from 'antd'
import { PropsWithChildren, FC } from 'react'
import { useDispatch } from 'react-redux'

import { BUSINESS_ACCOUNT_INVITE_MODAL } from '~/apps/consumer/components/BusinessAccountInviteModal/constants'
import { openModal } from '~/redux-modules/modals'

import { BannerSubcategory } from './logic'
import { useBannerContext } from './useBannersContext'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface SuccessBannerPropsType {}

function getBannerText(
    bannerSubcategory: BannerSubcategory,
    businessAccountName: string,
): { messageText: string; headerText: string; ctaText: string } {
    if (bannerSubcategory === BannerSubcategory.PO) {
        return {
            headerText: `Welcome to the ${businessAccountName} Business Account!`,
            messageText: `You now have access to company wide payment options. Make sure your colleagues have access and invite them to the account.`,
            ctaText: `Invite members`,
        }
    } else if (bannerSubcategory === BannerSubcategory.PREMIUM) {
        return {
            headerText: `Welcome to Fictiv Premium!`,
            messageText: ` As a member you now have access to Premium features such as Team Workspaces and Lead Time Optimizer. Take a tour to see what’s changed!`,
            ctaText: `Take a tour`,
        }
    }
    // should not fail unless additional bannerSubcategories are added
    throw new Error('attempted to get banner text without a valid bannerType')
}

export const SuccessBanner: FC<
    PropsWithChildren<SuccessBannerPropsType>
> = () => {
    const { businessAccountName, bannerSubcategory } = useBannerContext()
    const dispatch = useDispatch()

    if (!businessAccountName) {
        throw 'Expected business account name to be defined in banner context'
    }

    const { headerText, messageText, ctaText } = getBannerText(
        bannerSubcategory,
        businessAccountName,
    )

    function inviteUsers() {
        dispatch(openModal(BUSINESS_ACCOUNT_INVITE_MODAL))
    }

    return (
        <Alert
            message={headerText}
            description={messageText}
            style={{ marginBottom: '16px', alignItems: 'center' }}
            type={'success'}
            action={
                bannerSubcategory === BannerSubcategory.PO ? (
                    <Button onClick={inviteUsers}>{ctaText}</Button>
                ) : (
                    <Button href={'/pages/quotes?showBusinessAccountTour=true'}>
                        {ctaText}
                    </Button>
                )
            }
            showIcon
            closable={true}
        />
    )
}

export default SuccessBanner
